import { Drawer, Grid, Typography } from "@material-ui/core";
import ThorEvent from "components/ThorEvent/ThorEvent";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useStore } from "store/StoreConfigs";
import { eventsStyles } from "./EventsStyles";
import { EventType } from "models/thorEventModels/ActiveEvents";
import ThorPagination from "components/ThorPagination/ThorPagination";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PageRequest } from "api/sharedModels/PageRequest";
import AssignEventMenu, { AssignEventMenuProps } from "components/AssignEventMenu/AssignEventMenu";
export default observer(function EventsView() {
    const classes = eventsStyles();

    const { identityStore, commonStore, thorEventViewStore } = useStore();

    const [data, setData] = useState<AssignEventMenuProps>();

    const handleAssignData = (data: AssignEventMenuProps) => {
        setData(data);
    };

    useEffect(() => {
        const request: PageRequest = {
            pageNumber: thorEventViewStore.currentEventPage,
            customerId: identityStore.currentCustomerId,
            pageSize: 5,
        };
        thorEventViewStore.loadActiveEvents(request);
        commonStore.setCurrentView("events");
    }, [thorEventViewStore.currentEventPage]);

    return (
        <main className={classes.content}>
            <div className={classes.titleContainer}>
                <Typography className={classes.title}>Events</Typography>
                <Typography className={classes.subTitle}>
                    See a list of all recent events that have happened within the selected region & require evaluation
                </Typography>
            </div>

            {/* {(identityStore.userInfo?.email === "nikitin.denys@pm.me" ||
                "yevhenii.kovalenko@nixsolutions.com" ||
                "anatoliy.proniuk@nixsolutions.com" ||
                "polina.vandenko@nixsolutions.com") && (
                <Button
                    style={{ position: "absolute", right: "5%", top: "18%", backgroundColor: "#270ADC" }}
                    onClick={() => {
                        thorEventViewStore.resetAllEvents({ customerId: identityStore.currentCustomerId });
                    }}
                >
                    <Typography style={{ color: "white" }}>Reset all events</Typography>
                </Button>
            )} */}

            {thorEventViewStore.isEventsLoaded ? (
                <div style={{ maxHeight: "300px", maxWidth: "300px" }}>
                    <LoadingIndicator />
                </div>
            ) : (
                <>
                    {data && (
                        <Drawer anchor="right" open={thorEventViewStore.isAssignMenuOpen}>
                            <AssignEventMenu
                                eventId={data.eventId}
                                reviewerUserId={data.reviewerUserId}
                                qaUserId={data.qaUserId}
                                eventStatusId={data.eventStatusId}
                            />
                        </Drawer>
                    )}
                    <Grid container className={classes.gridContainer} justifyContent="space-between" xs={12}>
                        <Grid item className={classes.gridItem}>
                            Event Type
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Event ID
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Date & Time of Event Created
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Delivery ID
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Evaluation Status
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Priority
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            Assignees
                        </Grid>
                        <Grid item className={classes.gridItem}></Grid>
                    </Grid>
                    {thorEventViewStore.activeEvents.map((event) => (
                        <ThorEvent
                            key={event.eventId}
                            events={[
                                {
                                    eventType: Object.values(EventType)[Number.parseInt(event.type)],
                                    eventId: event.eventId,
                                    eventDate: event.createdAt,
                                    isClosed: event.isClosed,
                                    priority: event.priority,
                                    impactedDeliveries: event.impactedDeliveries,
                                    eventStatusId: event.eventStatusId,
                                    reviewerUserId: event.reviewerUserId,
                                    qaUserId: event.qaUserId,
                                    handleAssignData: handleAssignData,
                                },
                            ]}
                        />
                    ))}
                    {thorEventViewStore.activeEvents.length > 0 && (
                        <ThorPagination
                            page={thorEventViewStore.currentEventPage}
                            pages={thorEventViewStore.totalEventPages}
                            onPageChange={thorEventViewStore.moveToEventPage}
                            isLastPage={thorEventViewStore.isLastEventPage}
                            setPage={thorEventViewStore.setEventPage}
                        />
                    )}
                </>
            )}
        </main>
    );
});
